import Vue from 'vue'


import VueRouter from 'vue-router'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-default/index.css'

   Vue.use(VueRouter)
	Vue.use(ElementUI)

import './style/home.scss'

import Routes from './router/router'
import App from './App.vue'
// 






   const router = new VueRouter({
     	 routes:Routes
//		mode: 'history'
	// 	linkActiveClass: 'active'
   })

new Vue({
     router:router,
	  el: '#app',
	  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js